import { buildUrl } from "../config/conn";

/**
 * Global JSON fetcher. Automatically appends session & md_mode
 * params from the global connection state (set via ConnectionToggles).
 */
export async function httpJSON(path, options = {}, extraParams = {}) {
  const url = buildUrl(path, extraParams);
  const res = await fetch(url, options);
  const ct = res.headers.get('content-type') || '';
  const isJSON = ct.includes('application/json');
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const payload = isJSON ? await res.json() : await res.text();
      detail = (payload && (payload.detail || payload.error)) || payload || detail;
    } catch { /* ignore */ }
    throw new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
  }
  return isJSON ? res.json() : res.text();
}